import permissions from '../../Apollo/permissions';
import useMrMutation from '../../hooks/useMutation';

import { METHOD, PATH } from '../control-api';
import { mutation } from '../control-proxy-mutation-builder';
import { isNil } from 'lodash';
import transformErrors from './transform-errors';

export default function useTransformEvent({ onCompleted, options = {} } = {}) {
  const [executeMutation, response] = useMrMutation(mutation, {
    context: { permission: permissions.playbookTransformation },
    ...options,
    onCompleted: response => {
      if (!onCompleted) {
        return;
      }
      onCompleted(transformControlProxyResponse(response.control_proxy));
    },
  });

  const transformEvent = ({ clusterId, playbook, inputEvent, pipelineFilter = {}, originalEvent }) => {
    return executeMutation({
      variables: {
        path: PATH.TransformEventWithPlaybook,
        method: METHOD.POST,
        body: { playbook, inputEvent, pipelineFilter, originalEvent },
        clusterId,
      },
    });
  };
  const transformedResponse = transformResponse(response);

  return [transformEvent, transformedResponse];
}

function transformResponse(response) {
  const { data: { control_proxy: controlProxyResponse } = {}, ...rest } = response;

  if (!controlProxyResponse) {
    return rest;
  }

  return { ...transformControlProxyResponse(controlProxyResponse), ...rest };
}

function transformControlProxyResponse(controlProxyResponse) {
  const { data, errors } = controlProxyResponse;

  if (!isNil(errors)) {
    return { errors: transformErrors(errors) };
  }

  return { ...JSON.parse(data) };
}
